<div class="copy-popup" (mousedown)="onMouseDown($event)">
  <button type="button" class="copy-popup__button" aria-label="Copy selected text" (click)="copyRequested.next()">
    <mat-icon fontSet="outlined" aria-hidden="true">{{ icon() }}</mat-icon>
  </button>
  <span class="copy-popup__live" aria-live="polite">{{ message() }}</span>
</div>
